import { render, staticRenderFns } from "./ValueCard.vue?vue&type=template&id=ea3282d0&scoped=true"
import script from "./ValueCard.vue?vue&type=script&lang=js"
export * from "./ValueCard.vue?vue&type=script&lang=js"
import style0 from "./ValueCard.vue?vue&type=style&index=0&id=ea3282d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3282d0",
  null
  
)

export default component.exports